<ng-select
  #envSelect
  [fixNgSelectBottom]="envSelect"
  data-cy="envSelect"
  class="w-[150px] select-none text-base"
  (open)="openEnvSelect()"
  [loading]="envsListLoading"
  [items]="envsList"
  [clearable]="false"
  [searchable]="false"
  [disabled]="selectedProjectId === undefined || needSave === true"
  [(ngModel)]="selectedEnvId"
  (change)="envChange()"
  (keyup.esc)="$event.stopImmediatePropagation(); envSelect.blur()"
  (keyup.enter)="$event.stopImmediatePropagation(); envSelect.blur()"
  appendTo="body"
  placeholder="Env"
  bindLabel="envId"
  bindValue="envId"
>
  <ng-template ng-label-tmp let-item="item">
    <div class="ml-1 truncate"> {{ item.envId }}</div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    <div class="ml-1 truncate">{{ item.envId }}</div>
  </ng-template>
</ng-select>

<div *ngIf="needSave$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="user$ | async"></div>
